import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  selectedTabIndex: number;
  chargeTemplates: any[];
  selectedUnitId: any;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  selectedTabIndex: 0,
  chargeTemplates: [],
  selectedUnitId: null
};

export const unitUpdateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_UNIT_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_UNIT_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_UNIT_UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_UNIT_UPDATE_SWITCH_TAB:
      return {
        ...state,
        selectedTabIndex: action.payload?.index,
        selectedUnitId: action.payload?.unitId
      };

      case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        chargeTemplates: state.chargeTemplates.some(chargeTemplate => chargeTemplate.id === action.payload?.chargeTemplate.id) ?
        [
          action.payload?.chargeTemplate,
          ...state.chargeTemplates.filter(chargeTemplate => chargeTemplate.id !== action.payload?.chargeTemplate.id)
        ] : [action.payload?.chargeTemplate, ...state.chargeTemplates]
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_SUCCESS:
      return {
        ...state,
        chargeTemplates: [
          ...state.chargeTemplates.filter(chargeTemplate => chargeTemplate.id !== action.payload?.chargeTemplate.id)
        ]
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_AGENCY_FEE_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
       // isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_EVENT_CREATE_FAILURE:
    case Constants.GLOBAL_EVENT_UPDATE_FAILURE:
      const errorFields: string[] = [];

      if (action.payload?.err.fields.length > 0) {
        action.payload?.err.fields.forEach(error => {
          if(error === "content.name") {
            return errorFields.push("name");
          }
    
          if(error === "content.note") {
            return errorFields.push("note");
          }

          if (error === "propertyId" ||
              error === "unitId" ||
              error === "contractId" ||
              error === "companyId" ||
              error === "personId") {
            return errorFields.push("objectId");
          }

          return errorFields.push(error);
        });
      }
      
      return {
        ...state,
        isFetching: false,
        fields: errorFields,
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR:
    case Constants.GLOBAL_UNIT_UPDATE_CLEAR:
    case Constants.GLOBAL_EVENT_CREATE_CLEAR:
    case Constants.GLOBAL_EVENT_UPDATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
